import { useEffect, useRef, useState } from "react";
import Apiservice from "../Apiservice";
import moment from "moment";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";

const LMSReport = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [data, setData] = useState([]);
    const fromRef = useRef(null);
    const toRef = useRef(null);
    const employeeIdRef = useRef(null);
    const [errors, setErrors] = useState({});
    const [exams, setExams] = useState([]);
    const [selectedExam, setSelectedExam] = useState(0);

    const [loggedRoleId, setLoggedRoleId] = useState(0);
    const [loggedUserId, setLoggedUserId] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("access_token");
        setLoggedRoleId(localStorage.getItem('role_id'));
        setLoggedUserId(localStorage.getItem('user_id'));

        // Define custom headers
        const headers = {
            access_token: token, // Pass the token in the Authorization header
        };
        const fetchData = async () => {
            const result = await Apiservice.AllExam({ status: 0 }, headers);
            if (result.success === true) {
                setExams(result.data);
            } else {
                alert(result.message);
            }
        };
        fetchData();
    }, [])

    const validateForm = () => {
        const newErrors = {};
        if (!fromRef.current?.value.trim()) newErrors.from = "From Date is required";
        if (!toRef.current?.value.trim()) newErrors.to = "To Date is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const fetchData = async () => {
        if (!validateForm()) return;
        setLoading(true);
        let requestData = {};
        if (loggedRoleId == 1) {
            requestData = {
                from: fromRef.current.value,
                to: toRef.current.value,
                status: 0,
                employeeId: employeeIdRef.current?.value || "",
                examId: selectedExam,
                sort: "ASC"
            };
        }
        else {
            requestData = {
                from: fromRef.current.value,
                to: toRef.current.value,
                status: 0,
                userId: loggedUserId,
                examId: selectedExam,
                sort: "ASC"
            };
        }

        try {
            const token = localStorage.getItem("access_token");
            const headers = { access_token: token };
            const result = await Apiservice.Report(requestData, headers);
            console.log("result", result)

            if (result.success && Array.isArray(result.data)) {
                setData(result.data); // ✅ success with data
            } else {
                setData([]); // ✅ explicitly clear data
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.message || "No data found!",
                });
            }
        } catch (err) {
            console.error(err);
            setData([]); // ✅ also clear data on error
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: '<a href="#">Why do I have this issue?</a>'
            });
        } finally {
            setLoading(false);
        }
    };

    // const handleReview = (summary) => {
    //     navigate(`/quizreview/${summary.id}`, { state: { userDetails } });
    // };

    const handleEdit = (summary) => {
        console.log("quizedit", summary)
        navigate('/quizedit', {
            state: {
                quizId: summary.id,
                examId: summary.exam_id,
                fromReport: true,
                reportFilters: {
                    from: fromRef.current.value,
                    to: toRef.current.value,
                    employeeId: employeeIdRef.current?.value || "",
                    examId: selectedExam
                }
            }
        });
    };


    //for useLocation
    useEffect(() => {

        if (location.state?.refresh) {

            fromRef.current.value = location.state.filters.from;
            toRef.current.value = location.state.filters.to;

            if (employeeIdRef.current) {
                employeeIdRef.current.value =
                    location.state.filters.employeeId;
            }

            setSelectedExam(location.state.filters.examId);

            // report load
            setTimeout(() => {
                fetchData();
            }, 100);

        }

    }, []);



    const formatDate = (dateString) => moment(dateString).format("DD-MM-YYYY");

    const isEmployeeSelected = employeeIdRef.current?.value;

    const stickyHeaderStyle = {
        position: "sticky",
        top: 0,
        zIndex: 10,
        backgroundColor: "#212529",
        color: "#fff",
        verticalAlign: "middle"
    };
    return (
        <div className="container-fluid p-2 shadow" style={{ backgroundColor: "#f8f9fa", userSelect: "none" }}>
            {/* Filter Form */}
            <div
                className="card p-3 shadow-sm sticky-md-top"
                style={{
                    top: "10px",
                    zIndex: 1020,
                    background: "#fff",
                    borderRadius: "10px"
                }}
            >
                <div className="row gy-2 gx-2 align-items-end">
                    {/* From Date */}
                    <div className="col-md-2">
                        <label className="form-label form-label-sm">From</label>
                        <input
                            type="date"
                            ref={fromRef}
                            className={`form-control form-control-sm ${errors.from ? "is-invalid" : ""}`}
                        />
                        {errors.from && <div className="invalid-feedback">{errors.from}</div>}
                    </div>

                    {/* To Date */}
                    <div className="col-md-2">
                        <label className="form-label form-label-sm">To</label>
                        <input
                            type="date"
                            ref={toRef}
                            className={`form-control form-control-sm ${errors.to ? "is-invalid" : ""}`}
                        />
                        {errors.to && <div className="invalid-feedback">{errors.to}</div>}
                    </div>

                    {/* Quiz Dropdown */}
                    <div className="col-md-3">
                        <label className="form-label form-label-sm">Quiz</label>
                        <select
                            className="form-select form-select-sm"
                            value={selectedExam}
                            onChange={(e) => setSelectedExam(e.target.value)}
                        >
                            <option value="">Select By Quiz</option>
                            {exams.map((e, index) => (
                                <option value={e.id} key={index}>
                                    {e.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Employee ID */}
                    {
                        loggedRoleId == 1 && (
                            <div className="col-md-3">
                                <label className="form-label form-label-sm">Employee ID</label>
                                <input
                                    type="text"
                                    ref={employeeIdRef}
                                    className="form-control form-control-sm"
                                />
                            </div>
                        )
                    }


                    {/* Search Button */}
                    <div className="col-md-2 d-flex">
                        <button
                            className="btn btn-primary btn-sm w-100"
                            onClick={fetchData}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" />
                                    Searching...
                                </>
                            ) : (
                                <>
                                    <i className="bi bi-search me-1"></i>
                                    Search
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>





            {/* Profile Card */}
            <div className="row mt-4">
                <div className="col-12">
                    {employeeIdRef.current && employeeIdRef.current.value !== "" ? (
                        <div className="card mb-4">
                            <div className="card-body d-flex align-items-center">
                                <img
                                    src={data[0].userDetails[0]?.profileImage || ""}
                                    alt="Profile"
                                    className="rounded-circle me-3"
                                    style={{ width: "80px", height: "80px", objectFit: "cover" }}
                                />
                                <div>
                                    <h5 className="mb-1">
                                        {`${data[0].userDetails[0]?.firstName || ""} ${data[0].userDetails[0]?.lastName || ""}`}
                                    </h5>
                                    <p className="mb-1 text-muted">{data[0].userDetails[0]?.emailId || ""}</p>
                                    <p className="mb-0 text-muted">
                                        {`${data[0].userDetails[0]?.countryCode || ""} ${data[0].userDetails[0]?.mobileNo || ""}`}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ) : null}


                    {/* Table Section */}
                    <div
                        className="table-responsive shadow-sm rounded border"
                        style={{
                            maxHeight: "70vh",
                            overflowY: "auto",
                            overflowX: "auto"
                        }}
                    >
                        <table
                            className="table table-hover table-striped align-middle mb-0"
                            style={{
                                borderCollapse: "separate",
                                borderSpacing: 0
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={stickyHeaderStyle}>#</th>
                                    {!isEmployeeSelected && (
                                        <th style={stickyHeaderStyle}>Name</th>
                                    )}
                                    <th style={stickyHeaderStyle}>Exam</th>
                                    <th style={stickyHeaderStyle}>Attempt</th>
                                    <th style={stickyHeaderStyle}>Status</th>
                                    <th style={stickyHeaderStyle}>Marks</th>
                                    <th style={stickyHeaderStyle}>Grade</th>
                                    <th style={stickyHeaderStyle}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={isEmployeeSelected ? 7 : 8} className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status"></div>
                                            <div className="mt-2">Loading report...</div>
                                        </td>
                                    </tr>
                                ) : data.length > 0 ? (
                                    data.map((d, index) => {
                                        const user = d.userDetails?.[0] || {};
                                        const exam = d.examDetails?.[0] || {};
                                        const state = d.state ? JSON.parse(d.state) : {};

                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>

                                                {!isEmployeeSelected && (
                                                    <td>{`${user.firstName || ""} ${user.lastName || ""}`}</td>
                                                )}

                                                <td>{exam.name || "N/A"}</td>

                                                <td>{d.attempt}</td>

                                                <td>
                                                    <span
                                                        className={`badge ${d.grade >= 70
                                                            ? "bg-success"
                                                            : "bg-danger"
                                                            }`}
                                                    >
                                                        {d.grade >= 70
                                                            ? "Pass"
                                                            : "Fail"}
                                                    </span>

                                                    <div className="small text-muted">
                                                        <div>
                                                            Start: {state.startTime ? moment(state.startTime, "MM/DD/YYYY, hh:mm:ss A").format("DD/MM/YYYY, hh:mm:ss A") : "N/A"}
                                                        </div>

                                                        <div>
                                                            End: {state.endTime ? moment(state.endTime, "MM/DD/YYYY, hh:mm:ss A").format("DD/MM/YYYY, hh:mm:ss A") : "N/A"}
                                                        </div>
                                                        <div>Duration: {state.timeTaken || "N/A"}</div>
                                                        <div>Questions Attempted: {d.questionAttempt || 0}</div>
                                                    </div>
                                                </td>

                                                <td>{d.mark}</td>

                                                <td>{parseFloat(d.grade).toFixed(2)}%</td>

                                                <td>
                                                    {(loggedRoleId === 1 || loggedRoleId === "1") && (
                                                        <button
                                                            className="btn btn-sm btn-primary m-2"
                                                            onClick={() => handleEdit(d)}
                                                        >
                                                            Edit
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td
                                            colSpan={isEmployeeSelected ? 7 : 8}
                                            className="text-center py-4"
                                        >
                                            No Data Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LMSReport;
